/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  Campaign,
  CampaignFromJSON,
  CampaignFromJSONTyped,
  CampaignToJSON,
} from "./";

/**
 *
 * @export
 * @interface CalculateRequest
 */
export interface CalculateRequest {
  /**
   *
   * @type {Array<Campaign>}
   * @memberof CalculateRequest
   */
  campaigns: Array<Campaign>;
  /**
   *
   * @type {Array<string>}
   * @memberof CalculateRequest
   */
  conversionGroups: Array<string>;
}

export function CalculateRequestFromJSON(json: any): CalculateRequest {
  return CalculateRequestFromJSONTyped(json, false);
}

export function CalculateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    campaigns: (json["campaigns"] as Array<any>).map(CampaignFromJSON),
    conversionGroups: json["conversionGroups"],
  };
}

export function CalculateRequestToJSON(value?: CalculateRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    campaigns: (value.campaigns as Array<any>).map(CampaignToJSON),
    conversionGroups: value.conversionGroups,
  };
}
